import React from "react"

import { Grid } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { cx } from "ramda-extension"

const useStyles = makeStyles(() => ({
  itemTitle: {
    marginBottom: "5px",
    // marginTop: "18px !important",
  },
  container: {
    flexGrow: 1,
    // marginTop: "10px !important",
    overflow: "visible",
  },
  title: {
    "&::first-letter": {
      textTransform: "uppercase",
    },
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "4px",
    marginTop: "8px",
  },
}))

export const FilterContainer = ({ children, sx = {}, spacing = 1, maxWidth }) => {
  const { container } = useStyles()

  return (
    <Grid container className={container} {...{ sx, spacing }} style={{ maxWidth }}>
      {children}
    </Grid>
  )
}

export const FilterGroup = ({ children, key, groupTitle, xs }) => {
  const { title, itemTitle } = useStyles()

  return (
    <Grid item {...{ key, xs }}>
      {groupTitle ? <div className={cx(title, itemTitle)}>{groupTitle}</div> : null}
      {children}
    </Grid>
  )
}
